(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-collection-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const update = () => {
      const loaded = document.querySelectorAll('.product-grid__item').length;
      document.querySelectorAll('.jh-banner[data-after]').forEach((b) => {
        b.classList.toggle('jh-banner--wait', loaded < Number(b.dataset.after));
      });
    };
    document.addEventListener('DOMContentLoaded', () => {
      update();
      new MutationObserver(update).observe(document.body, { childList: true, subtree: true });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
